import React from 'react';
import { Typography, Button, Space, Affix ,Layout,Menu,Dropdown } from 'antd';
import { DownOutlined  } from "@ant-design/icons";
import { useContext } from 'react';
import SidebarWidthContext from '../Components/SidebarWidthContext';


const { Title } = Typography;
const { Header } = Layout;

 
const HeaderWithActions = ({ title, buttons,allowApprovals }) => {
    const sidebarWidth = useContext(SidebarWidthContext);

  // console.log('buttonsbuttons:',buttons);
    // Show first 5 buttons, rest go into the dropdown
    const filteredButtons = allowApprovals
      ? buttons
      : buttons.filter(button => button.label !== "Submit For Approval");

    const maxVisible = 5;
    const visibleButtons = filteredButtons.slice(0, maxVisible);
    const dropdownButtons = filteredButtons.slice(maxVisible);

  // console.log('dropdownButtons:',dropdownButtons);

  // Dropdown Menu
  const menu = (
    <Menu>
      {dropdownButtons.map((button, index) => (
        <Menu.Item key={index} onClick={button.onClick} disabled={button.disabled} danger={button.type === "danger"} >
          {button.label}
        </Menu.Item>
      ))}
    </Menu>
  );
  
return (
  <Header
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px 8px', // Reduced padding
      backgroundColor: '#F5F5F5',
      position: 'fixed',
      top: 55,
      left: sidebarWidth, // <-- use sidebar width here
      width: `calc(100% - ${sidebarWidth})`, // <-- adjust width
      zIndex: 1000,
      minHeight: 35, // Ensures no overlap
    }}
  >
    {/* Title Section */}
    <Title level={2} style={{ margin: 0, padding: 0, fontSize: '1.25rem' }}>
      {title}
    </Title>

    <Space size={6}> {/* Reduced space between buttons */}
      {visibleButtons.map((button, index) => (
        <Button
          key={index}
          type={button.type || 'default'}
          onClick={button.onClick}
          loading={button.loading || false}
          style={{ ...button.style, margin: 0, padding: '2px 8px' }} // Reduced button padding/margin
          danger={button.type === 'danger'}
        >
          {button.label}
        </Button>
      ))}
      {dropdownButtons.length > 0 && (
        <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
          <Button onClick={(e) => e.preventDefault()} style={{ margin: 0, padding: '2px 8px' }}>
            <DownOutlined />
          </Button>
        </Dropdown>
      )}
    </Space>
  </Header>
);
};

export default HeaderWithActions;
